import { createI18n } from 'vue-i18n'
import en from './locales/en'
import sl from './locales/sl'

// The ID portal is bilingual — English (default) and Slovenian.
export type AvailableLocales = 'sl' | 'en'

/**
 * A stored choice wins; otherwise the browser's own language list decides between the two, and
 * English is the default. There is no language picker on screen.
 */
const initialLocale = (): AvailableLocales => {
    const stored = localStorage.getItem('locale')
    if (stored === 'sl' || stored === 'en') return stored

    for (const language of navigator.languages ?? [navigator.language]) {
        const primary = language?.toLowerCase().split('-')[0]
        if (primary === 'sl') return 'sl'
        if (primary === 'en') return 'en'
    }

    return 'en'
}

const locale = initialLocale()
document.documentElement.lang = locale

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale,
    fallbackLocale:   'en',
    messages:         { sl, en },
    availableLocales: ['sl', 'en'],
})

export default i18n
